export const DEFAULT_OPTION = [
  {
    label: 'loading...',
    value: 'loading...',
    disabled: true,
  },
];
